 let Mj =
  {
    toFix : function (num,v){
      var vv = Math.pow(10,v);
      return Math.round(num*vv)/vv;
    },
    formatYear : function (dt){
      var now = new Date().getFullYear();
      return dt.replaceAll(now + "-" , "");
    }
}

export default Mj;



// WEBPACK FOOTER //
// ./src/components/lib/Mj.js